/**
 * Patient routes — everything available to a logged-in patient (their own
 * dashboard, booking, intake, treatment plan, exercises, invoices, etc.).
 */
import React from 'react';
import { Route } from 'react-router-dom';
import PatientDashboard from '../pages/patient/PatientDashboard';
import PatientBook from '../pages/patient/PatientBook';
import PatientExercises from '../pages/patient/PatientExercises';
import PatientAppointments from '../pages/patient/PatientAppointments';
import PatientInvoices from '../pages/patient/PatientInvoices';
import PatientProfile from '../pages/patient/PatientProfile';
import PatientMembership from '../pages/patient/PatientMembership';
import PatientProgress from '../pages/PatientProgress';
import PatientInterview from '../pages/PatientInterview';
import TreatmentPlanPage from '../pages/TreatmentPlan';
import PatientOutcomes from '../pages/PatientOutcomes';
import Storefront from '../pages/Storefront';
import Telehealth from '../pages/Telehealth';
import PatientFitness from '../pages/patient/PatientFitness';
import PromSurvey from '../pages/PromSurvey';
import PromTrend from '../pages/PromTrend';
import PatientHep from '../pages/patient/PatientHep';
import PatientMassageIntake from '../pages/patient/PatientMassageIntake';
import PatientHepGamification from '../pages/patient/PatientHepGamification';
import PatientPractitionerSearch from '../pages/patient/PatientPractitionerSearch';
import PatientTrustProfile from '../pages/PatientTrustProfile';
import PatientEducation from '../pages/patient/PatientEducation';
import RehabProgress from '../pages/patient/RehabProgress';

export const patientRoutes = (
  <>
    <Route path="/patient" element={<PatientDashboard />} />
    <Route path="/patient/book" element={<PatientBook />} />
    <Route path="/patient/appointments" element={<PatientAppointments />} />
    <Route path="/patient/interview" element={<PatientInterview mode="self" />} />
    <Route path="/patient/treatment-plan" element={<TreatmentPlanPage mode="self" />} />
    {/* Iter 133 — Standalone /patient/documents route removed. Uploads happen
        from inside the intake / interview via <MedicalDocsUpload/>. */}
    <Route path="/patient/exercises" element={<PatientExercises />} />
    <Route path="/patient/invoices" element={<PatientInvoices />} />
    <Route path="/patient/outcomes" element={<PatientOutcomes />} />
    <Route path="/patient/proms" element={<PromSurvey />} />
    <Route path="/patient/proms/:survey_key" element={<PromSurvey />} />
    <Route path="/patient/proms-trend/:survey_key" element={<PromTrend />} />
    <Route path="/patient/membership" element={<PatientMembership />} />
    <Route path="/patient/store" element={<Storefront />} />
    <Route path="/patient/appointments/:appointment_id/telehealth" element={<Telehealth />} />
    <Route path="/patient/profile" element={<PatientProfile />} />
    <Route path="/patient/fitness" element={<PatientFitness />} />
    <Route path="/patient/hep" element={<PatientHep />} />
    <Route path="/patient/massage-intake" element={<PatientMassageIntake />} />
    <Route path="/patient/progress" element={<RehabProgress />} />
    <Route path="/patient/rehab-progress" element={<RehabProgress />} />
    <Route path="/patient/hep-progress" element={<RehabProgress />} />
    <Route path="/patient/practitioners" element={<PatientPractitionerSearch />} />
    <Route path="/patient/trust" element={<PatientTrustProfile />} />
    <Route path="/patient/education" element={<PatientEducation />} />
  </>
);
